/**
 * Max's ten imperatives, in his order. The catalog carries the labels and counts;
 * this file only supplies the icon and the fallback ordering so the home screen
 * still renders in a stable shape if the server sends them out of order.
 */

import {
  Anchor,
  Compass,
  Handshake,
  Lightbulb,
  MessageSquareQuote,
  Milestone,
  Route,
  Scale,
  Sprout,
  Sunrise,
  type LucideIcon,
} from 'lucide-react';

export const IMPERATIVE_ORDER: string[] = [
  'competing_stakeholders',
  'shared_vision',
  'growing_colleagues',
  'holding_accountable',
  'delegating_ownership',
  'resolving_conflict',
  'leading_change',
  'recovering_setback',
  'incomplete_information',
  'difficult_communication',
];

export const IMPERATIVE_ICONS: Record<string, LucideIcon> = {
  competing_stakeholders: Scale,
  shared_vision: Compass,
  growing_colleagues: Sprout,
  holding_accountable: Anchor,
  delegating_ownership: Handshake,
  resolving_conflict: Handshake,
  leading_change: Route,
  recovering_setback: Sunrise,
  incomplete_information: Lightbulb,
  difficult_communication: MessageSquareQuote,
};

export function getImperativeIcon(imperativeId: string): LucideIcon {
  return IMPERATIVE_ICONS[imperativeId] ?? Milestone;
}

export function getImperativeOrder(imperativeId: string): number {
  const index = IMPERATIVE_ORDER.indexOf(imperativeId);
  return index === -1 ? IMPERATIVE_ORDER.length : index;
}

/** Presentation only: keep the authored objective and convert its opening verb. */
export function getPracticeTitle(label?: string): string {
  if (!label) return 'Leadership practice';
  const verbs: Record<string, string> = {
    Navigating: 'navigate', Aligning: 'align', Supporting: 'support',
    Holding: 'hold', Delegating: 'delegate', Resolving: 'resolve',
    Leading: 'lead', Recovering: 'recover', Making: 'make', Communicating: 'communicate',
  };
  const firstWord = label.split(' ')[0];
  return verbs[firstWord] ? `HOW to ${verbs[firstWord]}${label.slice(firstWord.length)}` : label;
}
